module.exports = __webpack_public_path__ + "static/media/CZ.51efa887.png";